<template>
<div>
  <p>Оценивайте свои финансовые возможности и риски.<br>Изучите все условия займа <a href="https://finmoll.ru/documents/" target="_blank" class="txtLink">finmoll.ru/documents</a></p>
</div>
</template>

<script>
export default {
  name: "docLinkDescr"
}
</script>

<style scoped>
  div{text-align: center;}
  #instTxtDesc{width: var(--font-size-300);
    padding: var(--font-size-30) 0 0 ;
    background: white;
    border-radius: var(--font-size-20);
    min-height: var(--font-size-130);
    margin: 0 auto var(--font-size-20);
    font-family: 'Roboto';}
  #instTxtDesc a{    color: var(--color-green);}
  #pdlTxtDesc{margin: var(--font-size-30) 0;}

  @media screen  and (min-width: 760px){
    #instTxtDesc{width:var(--font-size-1160);padding: var(--font-size-30) 0  var(--font-size-30);min-height: auto}
    
  }

  @media (min-width: 1170px) {
    
  }

</style>